/**
 * Sequence-diagram note — a sticky-yellow box (over / left of / right of a
 * participant) carrying free text.
 */

import { memo } from 'react'
import { NodeProps } from '@xyflow/react'
import type { SequenceNote } from '../../types/schema'

interface NoteData {
  label: string
  sequenceNote?: SequenceNote
}

function SequenceNoteNode({ data, width, height }: NodeProps) {
  const nodeData = data as unknown as NoteData
  const n = nodeData.sequenceNote
  const text = n?.text ?? nodeData.label
  return (
    <div
      style={{
        width: typeof width === 'number' ? width : 140,
        height: typeof height === 'number' ? height : 32,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        textAlign: 'center', padding: '4px 8px', boxSizing: 'border-box',
        background: '#fef9c3', border: '1px solid #fde047', borderRadius: 3,
        color: '#713f12', fontSize: 11, fontFamily: 'Inter, system-ui, sans-serif',
        boxShadow: '0 1px 2px rgba(0,0,0,0.06)', overflow: 'hidden',
      }}
      title={text}
    >
      {text}
    </div>
  )
}

export default memo(SequenceNoteNode)
